import { CancelFunctions } from 'components/common/types';

export type AdvancedAvailabilityStatus = 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED';

export interface AdvancedAvailabilityStatusData {
  exportId: string;
  status: AdvancedAvailabilityStatus;
  downloadUrl: string;
  filename: string;
  errorMessage: string;
}

export interface AdvancedAvailabilityResponse {
  data: AdvancedAvailabilityStatusData;
}

export const ONGOING_ADVANCED_AVAILABILITY_STATUSES = ['QUEUED', 'RUNNING'];

export const ADVANCED_AVAILABILITY_POLL_TIMEOUT_MS = 5 * 60 * 1000;

export const ADVANCED_AVAILABILITY_POLL_CANCEL_KEY = 'FETCH_ADVANCED_DIRECT_SALES_AVAILABILITY';

export const ADVANCED_AVAILABILITY_STATUS_REQUEST_CANCEL_KEY = 'FETCH_ADVANCED_DIRECT_SALES_AVAILABILITY_STATUS';

export interface AdvancedAvailabilityPayload {
  marketId: string;
  exportId: string;
  cancelFunctions: CancelFunctions;
}
